import TeacherCardSelectable from './TeacherCardSelectable';

export default TeacherCardSelectable;
